












































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  IUnreadNotification,
  UnreadNoti
} from '@/models/Notification'
import UnreadNotification from '@/components/UnreadNotification.vue'
import NotificationService from '@/services/NotificationService'
import GroupService from '@/services/GroupService'
import { getUnreadCount, updateUnreadCount } from '@/helpers/GetNotificationCount'
import i18n from '@/lang'
import { unreadNotificationRef } from '@/firebase'

import Notification from '@/store/modules/Notification'
import store from '@/store'
import { getModule } from 'vuex-module-decorators'
//@ts-ignore
import _ from 'lodash'

const NotificationModule = getModule(Notification, store)

@Component({
  components: {
    UnreadNotification
  }
})
export default class UnReadList extends Vue {
  groupsUserJoin: any[] = []
  groupFilterId: any = null
  groupFilterName: string = ''
  notifications: IUnreadNotification[] = []
  private page: number = 1
  showLoadMore: boolean = false
  private showLoadMoreByGroup: boolean = false
  isLoading: boolean = false
  isLoadingLoadMore: boolean = false
  private loadmoreAfterMarkReadNotifications: boolean = false
  unreadCount: number = this.$store.state.notification.unreadCount
  private optionSelectAllGroup: any = {
    id: null,
    name: i18n.t('notification.all_group')
  }
  private unsubscribe: any

  async created() {
    this.getAllGroupUserJoin()
    this.getNotificationUnread()
    getUnreadCount()

    // firebase get change unread notification
    this.handleRealtime()
  }

  destroyed() {
    this.unsubscribe()
  }

  @Watch('$store.state.userInfo.user.info.id')
  handleRealtime() {
    let trackingRealtime = true
    const userId = this.$store.state.userInfo.user.info.id
    if (!userId) return
    const start = this.moment()
      .subtract(1, 'm')
      .toDate()
    this.unsubscribe = unreadNotificationRef
      .where('userIds', 'array-contains', userId)
      .where('createdAt', '>', start)
      .onSnapshot((querySnapshot: any) => {
        if (trackingRealtime) {
          trackingRealtime = false
        } else {
          this.getNotificationUnread()
          getUnreadCount()
        }
      })
  }

  async getAllGroupUserJoin() {
    await GroupService.getAllGroupCompact().then(res => {
      if (res.status === 200) {
        this.groupsUserJoin = res.data.data
      }
    })

    this.groupsUserJoin.unshift(this.optionSelectAllGroup)
    this.groupFilterId = this.optionSelectAllGroup.id
    this.groupFilterName = this.optionSelectAllGroup.name
  }

  selectGroupFilter(index: number) {
    let selectedGroupFilter: any = this.groupsUserJoin[index]
    this.groupFilterId = selectedGroupFilter.id
    this.groupFilterName = selectedGroupFilter.name
  }

  /**
   * getNotificationUnreadCommon
   */
  async getNotificationUnreadCommon(group_id?: number) {
    this.isLoading = this.page <= 1
    this.isLoadingLoadMore = this.page > 1
    let limit = this.$store.state.setting.setting.setting_display
      .number_item_lists

    await NotificationService.getNotificationUnread(limit, this.page, group_id)
      .then(async res => {
        if (res.status === 200) {
          this.showLoadMore =
            this.page < res.data.meta.pagination.total_pages

          if (this.page === 1) {
            const total = res.data.meta.pagination.total
            if (group_id) {
              this.unreadCount = total
            } else {
              this.unreadCount = total
              updateUnreadCount(total)
            }
          }

          const data = res.data.data.map(
            (item: any) => new UnreadNoti(item, 'text-line-clamp-2')
          )

          if (this.loadmoreAfterMarkReadNotifications === true) {
            this.notifications = []
            this.notifications = [...this.notifications, ...data]
          } else {
            this.notifications = [...this.notifications, ...data]
          }
        }
      })
      .catch(err => {
        console.log(err)
      })

    this.isLoading = false
    this.isLoadingLoadMore = false
    this.loadmoreAfterMarkReadNotifications = false
  }

  /**
   * getNotificationUnread
   */
  getNotificationUnread() {
    // this.loadmoreAfterMarkReadNotifications = true
    this.getNotificationUnreadCommon()
  }

  /**
   * getNotificationUnreadByGroup
   */
  async getNotificationUnreadByGroup() {
    this.page = 1
    this.notifications = []
    this.loadmoreAfterMarkReadNotifications = false
    if (this.groupFilterId) {
      await this.getNotificationUnreadCommon(this.groupFilterId)
    } else {
      await this.getNotificationUnreadCommon()
      this.unreadCount = this.$store.state.notification.unreadCount
    }

    this.showLoadMoreByGroup = true
    ;(this.$refs.unreadNotification as any).isCheckAll = false
  }

  /**
   * loadMoreNotification
   */
  async loadMoreNotification() {
    this.page++
    if (this.loadmoreAfterMarkReadNotifications === true) {
      this.page = 1
    }
    await this.getNotificationUnreadCommon(
      this.groupFilterId && this.showLoadMoreByGroup ? this.groupFilterId : null
    )
    this.loadmoreAfterMarkReadNotifications = false
    ;(this.$refs.unreadNotification as any).isCheckAll = false
  }

  /**
   * markUnreadNotificationIds
   */
  async markUnreadNotificationIds(notificationIds: any) {
    this.$blockui.show()
    await NotificationService.markReadedNotification(notificationIds)
      .then(async res => {
        if (res.status === 200) {
          const readIds = notificationIds.notifications
          this.notifications = this.notifications.filter(
            ({ id }) => !readIds.includes(id)
          )

          await getUnreadCount()
          NotificationModule.CHANGE_NOTIFICATION_UNREAD()

          if (this.groupFilterId == null) {
            this.unreadCount = this.$store.state.notification.unreadCount
          } else {
            this.unreadCount = Math.max(0, this.unreadCount - readIds.length)
          }
          this.loadmoreAfterMarkReadNotifications = true

          // fetch new data if all current notifications are mark read and still have data to fetch
          if (!this.notifications.length && this.showLoadMore) {
            this.page = 1
            if (this.groupFilterId) {
              await this.getNotificationUnreadCommon(this.groupFilterId)
            } else {
              this.getNotificationUnread()
            }
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => this.$blockui.hide())

    this.loadmoreAfterMarkReadNotifications = true
  }

  handleLongText(text: string) {
    return _.truncate(text, {
      length: 50,
      separator: ' '
    })
  }
}
